import { createFileRoute, linkOptions } from '@tanstack/react-router'
import type { CompanyResponse, CoverageResponse, PolicyResponse } from 'types'

import GroupSheetContent from '@/components/sheets/group/group-sheet-content'
import { groupSheetPreload } from '@/components/sheets/group/group-sheet-preload'
import { ViewTransitionType } from '@/css/view-transition.types'

export const Route = createFileRoute('/app/data/groups/$uuid/')({
  component: RouteComponent,
  loader: ({ params, context: { queryClient } }) =>
    groupSheetPreload(params.uuid, queryClient),
})

const companyRowLink = (company: CompanyResponse) =>
  linkOptions({
    from: Route.fullPath,
    to: '/app/data/companies/$uuid',
    params: { uuid: company.uuid },
    target: '_blank',
    rel: 'noopener noreferrer',
  })

const policyRowLink = (policy: PolicyResponse) =>
  linkOptions({
    from: Route.fullPath,
    to: '/app/data/groups/$uuid/$policyUuid',
    params: { policyUuid: policy.uuid },
    viewTransition: { types: [ViewTransitionType.SheetParentToChild] },
  })

const coverageRowLink = (coverage: CoverageResponse) =>
  linkOptions({
    from: Route.fullPath,
    to: '/app/data/groups/$uuid/coverage/$coverageUuid',
    params: { coverageUuid: coverage.uuid },
    viewTransition: { types: [ViewTransitionType.SheetParentToChild] },
  })

// const insistenceRowLink = (insistence: InsistenceResponse) =>
//   linkOptions({
//     from: Route.fullPath,
//     to: '/app/data/groups/$uuid/coverage/$coverageUuid',
//     params: { coverageUuid: insistence.coverage.uuid },
//     viewTransition: { types: [ViewTransitionType.SheetParentToChild] },
//   })

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { uuid } = Route.useParams()

  const onGroupDeleted = () => {
    navigate({ to: '/app/data/groups' })
  }

  return (
    <GroupSheetContent
      groupUuid={uuid}
      companyRowLink={companyRowLink}
      policyRowLink={policyRowLink}
      coverageRowLink={coverageRowLink}
      // insistenceRowLink={insistenceRowLink}
      onGroupDeleted={onGroupDeleted}
    />
  )
}
